<div class="field-display">
  <div class="field-value">
    <mat-icon *ngIf="value === true" 
              [ngClass]="{'boolean-icon': true, 'boolean-icon-true': !invertColors, 'boolean-icon-false': invertColors}">
      check_small
    </mat-icon>
    <mat-icon *ngIf="value === false" 
              [ngClass]="{'boolean-icon': true, 'boolean-icon-false': !invertColors, 'boolean-icon-true': invertColors}">
      close_small
    </mat-icon>
    <span *ngIf="value !== true && value !== false">—</span>
  </div>
</div>
